import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type WorkspaceContextMenuInfoFragment = { __typename?: 'Workspace', id: string, name: string, projectNotificationsEnabled?: boolean | null };

export const WorkspaceContextMenuInfo = /*#__PURE__*/ gql`
    fragment WorkspaceContextMenuInfo on Workspace {
  id
  name
  projectNotificationsEnabled
}
    ` as unknown as DocumentNode<WorkspaceContextMenuInfoFragment, unknown>;

        

        
export const useWorkspaceContextMenuInfoFragment = (
  input: string | Omit<UseFragmentOptions<WorkspaceContextMenuInfoFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Workspace' } };
    return input;
  })();

  return useFragment<WorkspaceContextMenuInfoFragment>({
    fragment: WorkspaceContextMenuInfo,
    fragmentName: 'WorkspaceContextMenuInfo',
    ...options,
  });
};
  
        